import axios from 'axios';
import endpoints from 'services/endpoints';
import { UserInfo } from 'types/types';

export const validateLogin = (): Promise<UserInfo> =>
  axios.get(endpoints.authentication.USER_PROFILE).then((response) => response.data);
